(() => {
  'use strict';
  const collection = '/collections/dhanteras-special-ek-shubh-shuruaat';
  const offer = '/discount/DHANTERAS2026?redirect=' + encodeURIComponent(collection);
  function refresh() {
    document.querySelectorAll('[data-lf-dhanteras]').forEach(root => {
      const start = Date.parse(root.dataset.start);
      if (!Number.isFinite(start)) return;
      const active = Date.now() >= start;
      root.dataset.active = String(active);
      root.querySelectorAll('[data-lf-launch-status]').forEach(el => {
        el.textContent = active ? 'The Dhanteras offer is live' : 'Starts 6 November · 12:01 AM IST';
      });
      root.querySelectorAll('[data-lf-offer-link]').forEach(el => { el.href = active ? offer : collection; });
      root.querySelectorAll('[data-lf-cta]').forEach(el => {
        el.textContent = active ? 'Bring home something auspicious' : 'Choose your Dhanteras favourites';
      });
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-lf-copy-code]');
    if (!button) return;
    const status = button.closest('[data-lf-dhanteras]').querySelector('[data-lf-copy-status]');
    try {
      await navigator.clipboard.writeText('DHANTERAS2026');
      button.querySelector('[data-lf-copy-label]').textContent = 'Copied';
      if (status) status.textContent = 'Discount code copied: DHANTERAS2026';
    } catch (_) {
      if (status) status.textContent = 'Please copy the displayed code manually: DHANTERAS2026';
      button.querySelector('[data-lf-copy-label]').textContent = 'Select to copy';
    }
  });
  refresh();
  let timer = setInterval(refresh, 1000);
  document.addEventListener('visibilitychange', () => {
    clearInterval(timer);
    refresh();
    if (!document.hidden) timer = setInterval(refresh, 1000);
  });
  document.addEventListener('shopify:section:load', refresh);
})();
